import React from 'react';
import { AiFillEye } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { RiDownloadFill, RiFile2Fill } from 'react-icons/ri';
import { SavedFile } from '../../types/saved-file.type';
import './fileUploadItem.css';

export const FileUploadItem = ({ file, handleView, handleRemove }: FileUploadItemProps) => {
  return (
    <div className={'file-item'}>

      <RiFile2Fill className={'file-icon'} />

      <span className={'file-item-name'}>{file.name}</span>

      <span className={'file-item-type'}>{file.type}</span>

      <div className={'file-item-actions'}>
        {(handleView) && (
          (file.id)
            ? <RiDownloadFill className={'file-view-icon'} onClick={() => handleView?.()} />
            : <AiFillEye className={'file-view-icon'} onClick={() => handleView?.()} />)
        }
        {(handleRemove) && <MdDelete className={'file-delete-icon'} onClick={() => handleRemove?.()} />}
      </div>
    </div>
  );
};

interface FileUploadItemProps {
  file: SavedFile;
  handleView?: () => void;
  handleRemove?: () => void;
}